import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const TrailingSlashRedirect: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Only redirect if the path has a trailing slash and is not just "/"
    if (location.pathname !== '/' && location.pathname.endsWith('/')) {
      const newPath = location.pathname.slice(0, -1);
      navigate(newPath + location.search + location.hash, { replace: true });
    }
  }, [location, navigate]);

  return null; // This component doesn't render anything
};

export default TrailingSlashRedirect; 